import { axios, API } from '@/api';
import { getCorrectUrlParamsFormat } from '../../utilities/helper';
import { AxiosError } from 'axios';

export default {
  // Get all users
  async getUsers(params: any) {
    try {
      const url = API.getUsers() + '?' + getCorrectUrlParamsFormat(params);
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error('Error fetching users:', error.response?.data || error.message);
      } else {
        console.error('Unexpected error:', error);
      }
      throw error;
    }
  },

  async getUser(id) {
    try {
      const response = await axios.get(API.getUser(id));
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error('Error fetching user:', error.response?.data || error.message);
      } else {
        console.error('Unexpected error:', error);
      }
      throw error;
    }
  },

  async updateUser(user) {
    try {
      const response = await axios.put(API.updateUser(user.id), {
        roleId: user.role_id,
        isAvailableForVirtualEnrollments: user.isAvailableForVirtualEnrollments,
        agencyId: user.agencyId,
        languageId: user.languageId,
        resetEnvelopes: user.resetEnvelopes
      });
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error('Error updating user:', error.response?.data || error.message);
      } else {
        console.error('Unexpected error:', error);
      }
      throw error;
    }
  },

  async getUserInfo() {
    try {
      const response = await axios.get(API.fetchUserInfo());
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        console.error('Error fetching user info:', error.response?.data || error.message);
      } else {
        console.error('Unexpected error:', error);
      }
      throw error;
    }
  },
};
